import gql from 'graphql-tag';

export default gql`
  mutation loginWithAuthCode(
    $authCode: String!
    $application: LoginApplication!
  ) {
    loginWithAuthCode(authCode: $authCode, application: $application) {
      viewer {
        id
        userName
        firstName
        forceResetPassword
      }
      token
      errors
    }
  }
`;
